<div class="bg-img">
  <div layout="row" layout-padding="">
      <div flex="">
          <div class="contenedor">
              <!--<img src="/../../assets/images/generico/logosf.png" class="logo" alt="logo municipalidad"><br>-->
              <img src="/../../assets/images/generico/logo.png">
              <br>
              <!-- <h1 class="titulo1">Smart</h1>
              <h1 class="titulo2"> DOM</h1> -->
              <button mat-flat-button class="boton" color="accent" (click)="ir_servicios()">Servicios</button> 

              

          </div>
      </div>
  </div>
</div>